const warmupCooldown = {
  warmup: {
    name: "Warmup — Before Every KB Session",
    duration: "~8 min · Do this every single time",
    note: "Cold muscles + kettlebells = injury risk. This takes 8 minutes and is non-negotiable. Do it before every KB workout, no exceptions.",
    exercises: [
      {
        name: "Marching in Place",
        sets: "1 × 60 sec",
        cue: "Lift knees to hip height, swing opposite arm. Start slow and build pace. Gets blood moving to legs and core without any joint stress.",
        muscles: "Full body activation",
      },
      {
        name: "Hip Circle",
        sets: "1 × 10 each dir",
        cue: "Feet shoulder-width, hands on hips. Draw large circles with your hips — clockwise then counter-clockwise. Keep upper body still. Loosens the hip joint before any hinging or squatting.",
        muscles: "Hip mobility",
      },
      {
        name: "Leg Swing (forward/back)",
        sets: "1 × 10 each leg",
        cue: "Hold a wall with one hand. Swing the free leg forward and back — let momentum carry it, don't force range. Opens hamstrings and hip flexors before deadlifts.",
        muscles: "Hamstrings, hip flexors",
      },
      {
        name: "Leg Swing (side to side)",
        sets: "1 × 10 each leg",
        cue: "Same position, now swing leg across your body and out to the side. Loosens inner thigh and glute. Essential before any single-leg work.",
        muscles: "Hip abductors, groin",
      },
      {
        name: "Shoulder Roll",
        sets: "1 × 10 each dir",
        cue: "Roll both shoulders forward in large circles 10 times, then backward 10 times. Opens the chest and primes the shoulder joint before any pressing or rowing.",
        muscles: "Shoulders, upper back",
      },
      {
        name: "Arm Circle",
        sets: "1 × 10 each dir",
        cue: "Full arm circles — extend arms wide and rotate from the shoulder. Small then large. Both directions. Prepares shoulder for overhead work and halos.",
        muscles: "Shoulder joint, rotator cuff",
      },
      {
        name: "Bodyweight Glute Bridge",
        sets: "1 × 12",
        cue: "Same as the KB version but no weight. Feet flat, drive hips up, squeeze glutes at top. Wake-up call for your glutes before they need to work hard.",
        muscles: "Glutes, core",
      },
      {
        name: "Cat-Cow",
        sets: "1 × 8 slow reps",
        cue: "On hands and knees. Inhale: drop belly toward floor, lift chest and tailbone (cow). Exhale: round spine toward ceiling, tuck chin and pelvis (cat). Move slowly. Mobilises the full spine before any loaded hinging.",
        muscles: "Spine mobility, core",
      },
    ],
  },
  cooldown: {
    name: "Cooldown — After Every Run",
    duration: "~8 min · Do this after the run, not after KB",
    note: "Your HR is elevated after running — stopping abruptly causes blood to pool in the legs and slows recovery. Walk first, then stretch. Never skip this.",
    exercises: [
      {
        name: "Easy Walk",
        sets: "1 × 3 min",
        cue: "Keep moving at a comfortable walking pace. Let HR drop below 110 bpm naturally. Non-optional — prevents dizziness and speeds recovery.",
        muscles: "Full body HR recovery",
      },
      {
        name: "Standing Quad Stretch",
        sets: "1 × 30 sec each leg",
        cue: "Stand on one leg, pull the other foot toward your glute. Hold the ankle, not the toes. Keep both knees together and stand tall. Hold a wall if needed.",
        muscles: "Quadriceps",
      },
      {
        name: "Standing Hamstring Stretch",
        sets: "1 × 30 sec each leg",
        cue: "Extend one leg forward, rest heel on a low step or curb. Hinge gently from the hip — don't round your back. Feel the stretch along the back of the thigh.",
        muscles: "Hamstrings",
      },
      {
        name: "Hip Flexor Lunge Stretch",
        sets: "1 × 30 sec each side",
        cue: "Step one foot forward into a low lunge. Back knee on the floor (use a towel on hard surfaces). Push hips slightly forward until you feel the stretch at the front of the back hip.",
        muscles: "Hip flexors, psoas",
      },
      {
        name: "Calf Stretch",
        sets: "1 × 30 sec each leg",
        cue: "Face a wall, hands on it. Step one foot back, press heel firmly into floor, lean forward. Keep back leg straight. Neglecting this leads to tight achilles over time.",
        muscles: "Calves, achilles",
      },
      {
        name: "Seated Glute Stretch",
        sets: "1 × 30 sec each side",
        cue: "Sit on floor. Cross one ankle over the opposite knee (figure-4 shape). Gently press the crossed knee away from you, or lean forward slightly. Releases the glute and piriformis.",
        muscles: "Glutes, piriformis",
      },
      {
        name: "Child's Pose",
        sets: "1 × 60 sec",
        cue: "Kneel, sit back toward your heels, extend arms forward on the floor, forehead down. Breathe slowly and deeply. Decompresses the lower back after the impact of running. Hold the full minute.",
        muscles: "Lower back, hips, shoulders",
      },
    ],
  },
};

export default warmupCooldown;
